if (!customElements.get('coming-soon-form')) {
  class ComingSoonForm extends HTMLElement {
    constructor() {
      super();

    }

    connectedCallback() {
      const init = () => {
        this.form = this.querySelector('form');
        this.email = this.querySelector('input[type="email"]');
        this.klaviyoListId = this.getAttribute('data-klaviyo-list-id');
        this.companyId = this.getAttribute('data-company-id');
        console.log(this.form, 'this.form');
        console.log(this.klaviyoListId, 'this.klaviyoListId');

        if (this.klaviyoListId && this.form) {
          this.form.addEventListener('submit', this.sendForm.bind(this));
          return true;
        }
        return false;
      };

      if (!init()) {
        const observer = new MutationObserver(() => {
          if (init()) observer.disconnect();
        });
        observer.observe(this, { childList: true, subtree: true });
      }
    }
    formData() {
      return {
        method: 'POST',
        headers: {revision: '2024-02-15', 'content-type': 'application/json'},
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Coming Soon Form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: (this.querySelector('input[type="email"]')) ? this.querySelector('input[type="email"]').value : '',
                  }
                }
              }
            },
            relationships: {list: {data: {type: 'list', id: this.klaviyoListId}}}
          }
        })
      };
    }
    showMessage(type) {
      this.querySelector('.signup-' + type).classList.remove('hide');

      if (type === 'failure' ) {
        setTimeout(() => {
          this.querySelector('.signup-' + type).classList.add('hide');
        }, 4000)
      } else {
        this.querySelector('.form-inputs').classList.add('hide');
        let data = {};
        data.action = 'in_product';
        data.reason = 'pre_launch';
        data.email = this.email.value;
        data.product_name = this.email.getAttribute('data-product-name');
        data.product_id = this.email.getAttribute('data-product-id');
        _learnq.push(['interest', data ]);
      }
    }
    sendForm(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      const _this = this;

      if (this.emailValidation()) {
        fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`, this.formData())
          .then(response => {(response.status === 202) ? _this.showMessage("success"):  _this.showMessage('failure')})
          // .catch(err => {console.error(err); _this.showMessage('failure')});

      } else {
        this.showMessage('failure');
      }
    }

    emailValidation() {
      if (this.email) {
        const emailValue = this.email.value;
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const result = re.test(emailValue);

        return result && result !== ''
      } else {
        return true
      }
    }
  }
  customElements.define("coming-soon-form", ComingSoonForm);
}

if (!customElements.get('permanent-oos')) {
  class PermanentOutOfStockForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.klaviyoListId = this.getAttribute('data-klaviyo-list-id');
      this.email = this.querySelector('input[type="email"]');
      this.companyId = this.getAttribute('data-company-id');

      if (this.klaviyoListId) {
        this.form.addEventListener('submit', this.sendForm.bind(this));
      } else {
        return console.error('Klaviyo form id not found.');
      }
    }
    formData() {
      return {
        method: 'POST',
        headers: {revision: '2024-02-15', 'content-type': 'application/json'},
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Permanent Out Of Stock Form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: (this.querySelector('input[type="email"]')) ? this.querySelector('input[type="email"]').value : '',
                  }
                }
              }
            },
            relationships: {list: {data: {type: 'list', id: this.klaviyoListId}}}
          }
        })
      };
    }
    showMessage(type) {
      this.querySelector('.signup-' + type).classList.remove('hide');

      if (type === 'failure' ) {
        setTimeout(() => {
          this.querySelector('.signup-' + type).classList.add('hide');
        }, 4000)
      } else {
        this.querySelector('.form-inputs').classList.add('hide');
        let data = {};
        data.action = 'in_product';
        data.reason = 'pre_launch';
        data.email = this.email.value;
        data.product_name = this.email.getAttribute('data-product-name');
        data.product_id = this.email.getAttribute('data-product-id');
        _learnq.push(['interest', data ]);
      }
    }
    sendForm(event) {
      event.preventDefault();
      const _this = this;

      if (this.emailValidation()) {
        fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`, this.formData())
          .then(response => {(response.status === 202) ? _this.showMessage("success"):  _this.showMessage('failure')})
        // .catch(err => {console.error(err); _this.showMessage('failure')});

      } else {
        this.showMessage('failure');
      }
    }

    emailValidation() {
      if (this.email) {
        const emailValue = this.email.value;
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const result = re.test(emailValue);

        return result && result !== ''
      } else {
        return true
      }
    }
  }
  customElements.define("permanent-oos", PermanentOutOfStockForm);
}

if (!customElements.get('oos-form')) {
  class OutOfStockForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const init = () => {
        this.form = this.querySelector('form');
        this.email = this.querySelector('input[type="email"]');
        this.variantId = this.email?.getAttribute('data-variant-id');
        this.klaviyoListId = this.getAttribute('data-klaviyo-list-id');
        this.companyId = this.getAttribute('data-company-id');

        console.log(this.form, 'this.form');
        console.log(this.klaviyoListId, 'this.klaviyoListId');

        if (this.form && !this.form.dataset.listenerAttached) {
          this.form.dataset.listenerAttached = true;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        return Boolean(this.form && this.email && this.klaviyoListId);
      };

      if (!init()) {
        const observer = new MutationObserver(() => {
          if (init()) observer.disconnect();
        });
        observer.observe(this, { childList: true, subtree: true });
      }
    }

    onSubmitHandler(e) {
      e.preventDefault();
      e.stopPropagation();

      const formData = new FormData(this.form);
      const email = formData.get('email');

      if (!this.validateEmail(email)) {
        this.showMessage('failure');
        return;
      }

      const config = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2024-02-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email }
                }
              },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${this.variantId}`
                }
              }
            }
          }
        })
      };

      this.sendRequest(config);
    }

    sendRequest(config) {
      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.companyId}`, config)
        .then(response => {
          (response.status === 202)
            ? this.showMessage('success')
            : this.showMessage('failure');
        });
    }

    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    }

    showMessage(type) {
      const msg = this.querySelector('.signup-' + type);
      if (msg) msg.classList.remove('hide');

      if (type === 'failure') {
        setTimeout(() => msg?.classList.add('hide'), 4000);
      } else {
        this.querySelector('.form-inputs')?.classList.add('hide');
      }
    }
  }

  customElements.define('oos-form', OutOfStockForm);
}

